import './App.css';
import { Unity, useUnityContext } from 'react-unity-webgl';
import backGroundBlur from './assests/loading_screen_blur.png';
import { useEffect, useState } from 'react';

function App() {
    const { unityProvider, isLoaded, loadingProgression } = useUnityContext({
        loaderUrl: 'webgl/WebGL.loader.js',
        dataUrl: 'webgl/WebGL.data',
        frameworkUrl: 'webgl/WebGL.framework.js',
        codeUrl: 'webgl/WebGL.wasm',
    });

    const loadingPercentage = Math.round(loadingProgression * 100);

    // ! Inner Height/Width used for the mobile build
    // const innerWdth = window.innerWidth + 'px';
    // const innerHght = window.innerHeight + 'px';

    const [count, setCount] = useState(0);
    const [message, setMessage] = useState('');
    const [author, setAuthor] = useState('');
    const [addClass, setAddClass] = useState(false);
    const initialMessage = ` “ [they] are mentioned in many historical books, but as a one-liner and a footnote…What is not mentioned is their intellectual contribution…”`;
    const initialAuthor = 'Advocate Tembeka Ngcukaitobi';

    useEffect(() => {
        const userMessages = [
            `“…the archive is not a neutral space that will just hold everything… People decide what is in and what is out…” `,
            `“...it's very clear… that the life stories of the Sogas have been marginalised from public discourse.”`,
            `“… a complete role model for me is Charlotte Maxeke, because if you consider the story of… how she became a science graduate in a system that was telling you that wasn’t your job. (It) must have been a phenomenal breaking of boundaries and… courage to stand your ground, and… even begin to dream… of a different society...”`,
            ` “ [they] are mentioned in many historical books, but as a one-liner and a footnote…What is not mentioned is their intellectual contribution…”`,
        ];

        const authors = [
            'Dr Athambile Masola',
            'Dr Joanne Ruth Davis',
            'Ferial Haffajee',
            'Advocate Tembeka Ngcukaitobi',
        ];

        const interval = setInterval(() => {
            setAddClass(true);
            setCount((prev) => prev + 1);
            setMessage((prev) => {
                return (prev = userMessages[count % userMessages.length]);
            });
            setAuthor((prev) => {
                return (prev = authors[count % authors.length]);
            });
        }, 6000);
        return () => {
            clearInterval(interval);
        };
    }, [count]);

    return (
        <>
            <div className='unity-content'>
                {isLoaded === false && (
                    <div
                        style={{
                            backgroundImage: `url(${backGroundBlur})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            color: '#fff',
                            width: '100%',
                            height: '100%',
                            position: 'absolute',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'column',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <div className='clock-face'>
                                <div className='hour-hand'></div>
                                <div className='minute-hand'></div>
                            </div>
                            <p className='pps-font'>{loadingPercentage}%</p>
                        </div>
                        {addClass === true ? (
                            <div
                                // ! Desktop
                                style={{
                                    position: 'absolute',
                                    bottom: '20%',
                                    textAlign: 'center',
                                    width: '40%',
                                }}
                                // ! Mobile
                                // style={{
                                //     position: 'absolute',
                                //     bottom: '10%',
                                //     textAlign: 'center',
                                //     width: '90%',
                                // }}
                                // ! Desktop
                                className={
                                    addClass === true
                                        ? 'text-fade text-width-desktop'
                                        : ''
                                }
                                // ! Mobile
                                // className={addClass === true ? 'text-fade' : ''}
                            >
                                <p
                                    style={{
                                        fontFamily: 'Playfair Display, serif',
                                        letterSpacing: '1px',
                                    }}
                                >
                                    {message}
                                </p>
                                <p
                                    style={{
                                        fontFamily: 'Playfair Display, serif',
                                        color: '#ac945e',
                                        letterSpacing: '1px',
                                    }}
                                >
                                    {author}
                                </p>
                            </div>
                        ) : (
                            <div
                                // ! Desktop
                                style={{
                                    position: 'absolute',
                                    bottom: '20%',
                                    textAlign: 'center',
                                    width: '40%',
                                }}
                                className='text-fade text-width-desktop'
                                // ! Mobile
                                // style={{
                                //     position: 'absolute',
                                //     bottom: '10%',
                                //     textAlign: 'center',
                                //     width: '90%',
                                // }}
                                // className='text-fade'
                            >
                                <p
                                    style={{
                                        fontFamily: 'Playfair Display, serif',
                                        letterSpacing: '1px',
                                    }}
                                >
                                    {initialMessage}
                                </p>
                                <p
                                    style={{
                                        fontFamily: 'Playfair Display, serif',
                                        color: '#ac945e',
                                        letterSpacing: '1px',
                                    }}
                                >
                                    {initialAuthor}
                                </p>
                            </div>
                        )}
                    </div>
                )}
                <Unity
                    unityProvider={unityProvider}
                    // ! Desktop Build
                    style={{
                        width: '100%',
                        height: '100%',
                        position: 'absolute',
                        overflowY: 'auto',
                    }}
                    // ! Mobile Build
                    // style={{
                    //     width: `${innerWdth}`,
                    //     height: `${innerHght}`,
                    // }}
                    devicePixelRatio={1.5}
                />
            </div>

            {/* Mobile Landscape View */}
            {/* <div
                className='landscape pps-font'
                style={{
                    display: 'none',
                    width: `100%`,
                    height: `100vh`,
                    backgroundColor: 'black',
                }}
            >
                <p>Please use portrait mode to view this app</p>
            </div> */}
        </>
    );
}

export default App;
